import React from "react";
import astrologersImg from "../../assets/image/astrologer.png";
import bgImg from "../../assets/image/AB .jpg";

const CallBanner = () => {
  const bannerStyle = {
    container: {
      position: "relative",
      width: "calc(100% - 60px)",
      maxWidth: "1400px",
      height: "auto",
      minHeight: "250px",
      margin: "40px auto 40px",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0px 50px",
      background: `url('${bgImg}')`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      borderRadius: "10px",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    },
    sparkles: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      backgroundImage: `
        radial-gradient(2px 2px at 10% 20%, #ff69b4, rgba(255, 105, 180, 0)),
        radial-gradient(2px 2px at 30% 70%, #ffd700, rgba(255, 215, 0, 0)),
        radial-gradient(1px 1px at 50% 50%, white, rgba(255, 255, 255, 0)),
        radial-gradient(1px 1px at 80% 10%, #ff69b4, rgba(255, 105, 180, 0)),
        radial-gradient(2px 2px at 70% 80%, white, rgba(255, 255, 255, 0)),
        radial-gradient(1px 1px at 20% 80%, #ffd700, rgba(255, 215, 0, 0)),
        radial-gradient(2px 2px at 90% 60%, #ff1493, rgba(255, 20, 147, 0)),
        radial-gradient(1px 1px at 40% 30%, white, rgba(255, 255, 255, 0))
      `,
      backgroundSize: "200% 200%",
      backgroundRepeat: "repeat",
      animation: "sparkle 6s ease-in-out infinite",
    },
    content: {
      position: "relative",
      zIndex: 2,
      flex: "1",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      maxWidth: "60%",
      textAlign: "center",
    },
    mainHeading: {
      fontSize: "clamp(32px, 4vw, 56px)",
      fontWeight: "bold",
      lineHeight: "1.2",
      marginBottom: "15px",
      textShadow: "3px 3px 10px rgba(0, 0, 0, 0.6)",
      fontFamily: "'Georgia', serif",
      letterSpacing: "1px",
    },
    taglineContainer: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      flexWrap: "wrap",
      marginBottom: "20px",
      fontSize: "clamp(18px, 2.5vw, 32px)",
      fontWeight: "bold",
      fontFamily: "'Georgia', serif",
      justifyContent: "center",
    },
    orangeTag: {
      backgroundColor: "#ff7a00",
      color: "white",
      padding: "8px 16px",
      borderRadius: "6px",
      display: "inline-block",
      boxShadow: "0 4px 10px rgba(255, 122, 0, 0.3)",
    },
    yellowTag: {
      backgroundColor: "#ffeb3b",
      color: "#1a0033",
      padding: "8px 16px",
      borderRadius: "6px",
      display: "inline-block",
      fontWeight: "bold",
      boxShadow: "0 4px 10px rgba(255, 235, 59, 0.3)",
    },
    subheading: {
      fontSize: "clamp(14px, 1.8vw, 18px)",
      lineHeight: "1.5",
      marginBottom: "25px",
      color: "rgba(255, 255, 255, 0.95)",
      textShadow: "2px 2px 6px rgba(0, 0, 0, 0.5)",
      fontFamily: "'Georgia', serif",
      maxWidth: "100%",
    },
    button: {
      padding: "14px 35px",
      backgroundColor: "white",
      color: "#89184a",
      fontSize: "clamp(14px, 1.8vw, 18px)",
      fontWeight: "bold",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      textDecoration: "none",
      display: "inline-flex",
      alignItems: "center",
      gap: "10px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
      textTransform: "uppercase",
      letterSpacing: "1px",
    },
    buttonHover: {
      backgroundColor: "#89184a",
      color: "white",
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.4)",
    },
    playIcon: {
      width: "24px",
      height: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
      fontSize: "16px",
    },
    astrologersSection: {
      position: "relative",
      zIndex: 2,
      flex: "0 0 auto",
      display: "block",
      textAlign: "center",
      width: "clamp(200px, 35vw, 500px)",
      height: "350px",
    },
    astrologer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-end",
      height: "120%",
    },
    astrologerImage: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
    },
    responsiveWrapper: {
      position: "relative",
      zIndex: 2,
      display: "flex",
      gap: "40px",
      width: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
    },
  };

  const [hoveredButton, setHoveredButton] = React.useState(false);

  const globalStyles = `
    @keyframes sparkle {
      0%, 100% { opacity: 0.5; }
      50% { opacity: 1; }
    }

    @media (max-width: 1024px) {
      .responsive-wrapper {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
      }
      .banner-content {
        max-width: 100% !important;
        text-align: center;
        align-items: center !important;
      }
      .banner-heading {
        font-size: 40px !important;
        margin-bottom: 12px !important;
      }
      .tagline-container {
        font-size: 24px !important;
        margin-bottom: 15px !important;
      }
      .banner-subheading {
        font-size: 16px !important;
        margin-bottom: 15px !important;
      }
      .banner-astrologers {
        width: clamp(160px, 50vw, 350px) !important;
        height: 280px !important;
      }
    }

    @media (max-width: 768px) {
      .banner-container {
        padding: 25px 20px !important;
        min-height: auto !important;
      }
      .responsive-wrapper {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
      }
      .banner-content {
        max-width: 100% !important;
        text-align: center;
        align-items: center !important;
      }
      .banner-heading {
        font-size: 32px !important;
        text-align: center;
        margin-bottom: 12px !important;
      }
      .tagline-container {
        font-size: 20px !important;
        margin-bottom: 12px !important;
        justify-content: center !important;
      }
      .banner-subheading {
        font-size: 14px !important;
        text-align: left;
        max-width: 100% !important;
        margin-bottom: 15px !important;
      }
      .banner-button {
        padding: 12px 30px !important;
        font-size: 14px !important;
      }
      .banner-astrologers {
        width: clamp(150px, 55vw, 300px) !important;
        height: 240px !important;
      }
    }

    @media (max-width: 480px) {
      .banner-container {
        padding: 18px 15px !important;
        min-height: auto !important;
        margin: 30px auto 30px !important;
      }
      .responsive-wrapper {
        flex-direction: column;
        gap: 0 !important;
      }
      .banner-content {
        max-width: 100% !important;
        text-align: left;
        align-items: flex-start !important;
        margin-bottom: 0 !important;
      }
      .banner-heading {
        font-size: 26px !important;
        text-align: left;
        margin-bottom: 10px !important;
        line-height: 1.2 !important;
      }
      .tagline-container {
        font-size: 18px !important;
        margin-bottom: 10px !important;
      }
      .banner-subheading {
        font-size: 12px !important;
        text-align: left;
        max-width: 100% !important;
        margin-bottom: 12px !important;
        line-height: 1.4 !important;
      }
      .banner-button {
        padding: 11px 25px !important;
        font-size: 13px !important;
        letter-spacing: 0 !important;
      }
      .banner-astrologers {
        width: clamp(140px, 75vw, 240px) !important;
        height: 200px !important;
        margin-top: 0 !important;
      }
    }
  `;

  return (
    <>
      <style>{globalStyles}</style>
      <div style={bannerStyle.container} className="banner-container">
        <div style={bannerStyle.sparkles}></div>

        <div
          style={bannerStyle.responsiveWrapper}
          className="responsive-wrapper"
        >
          <div style={bannerStyle.content} className="banner-content">
            <h1 style={bannerStyle.mainHeading} className="banner-heading">
              Confused about
            </h1>
            <div
              style={bannerStyle.taglineContainer}
              className="tagline-container"
            >
              <span style={bannerStyle.orangeTag}>LOVE</span>
              <span style={{ color: "white" }}>,</span>
              <span style={bannerStyle.orangeTag}>JOB</span>
              <span style={{ color: "white" }}>&</span>
              <span style={bannerStyle.orangeTag}>MARRIAGE</span>
              <span style={{ color: "white" }}>?</span>
            </div>
            <p style={bannerStyle.subheading} className="banner-subheading">
              <span style={bannerStyle.yellowTag}>
                India's Best Astrology Consultation
              </span>
            </p>
            <a
              href="https://play.google.com/store/apps/details?id=com.astrobhagyap"
              target="_blank"
              rel="noopener noreferrer"
              className="banner-button"
              style={{
                ...bannerStyle.button,
                ...(hoveredButton ? bannerStyle.buttonHover : {}),
              }}
              onMouseEnter={() => setHoveredButton(true)}
              onMouseLeave={() => setHoveredButton(false)}
            >
              <span style={bannerStyle.playIcon}>▶</span>
              Install Now
            </a>
          </div>

          <div
            style={bannerStyle.astrologersSection}
            className="banner-astrologers"
          >
            <div style={bannerStyle.astrologer}>
              <img
                src={astrologersImg}
                alt="Astrologers"
                style={bannerStyle.astrologerImage}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CallBanner;
